/*--------------------------------------------------------*/

export let capitalize = (str) => str && str.charAt(0).toUpperCase() + str.slice(1);

/*--------------------------------------------------------*/

export let hexToRgba = (color,opacity) => {
	if (!color)
		return color;
		
	color = color.substr(1);
	
	let colors = (color.length === 3) ?
		[color[0]+color[0], color[1]+color[1], color[2]+color[2]] :
		[color.substr(0,2), color.substr(2,2), color.substr(4,2)];

	colors = colors.map((s) => parseInt(s,16));
	colors.push(opacity === null ? 1 : opacity);

	return 'rgba('+colors.join(',')+')';
}

/*--------------------------------------------------------*/

export let dispatchEvent = (target,message) => {
	if (!target)
		return;

	let event = new CustomEvent(message, {bubbles: true});
	target.dispatchEvent(event);
}

/*--------------------------------------------------------*/

let debounceTimeouts = {};
export let debounce = (func,time) => {
	clearTimeout(debounceTimeouts[func]);
	debounceTimeouts[func] = setTimeout(() => func(), time);
}

/*--------------------------------------------------------*/

export let getFontStyle = (contextMgr,path) => {
	let style = {
		fontFamily: capitalize(contextMgr.get(path+".family")),
		fontSize: contextMgr.get(path+"Size") || contextMgr.get(path+".size"), // on mobile the size can be changed separately from the other settings
		fontWeight: contextMgr.get(path+".style.bold") === true ? 600 : null,
		fontStyle: contextMgr.get(path+".style.italic") === true ? 'italic' : null,
		textDecoration: contextMgr.get(path+".style.underline") === true ? 'underline' : null,
	};

	// remove empty attributes
	Object.keys(style).forEach((key) => !style[key] && delete style[key]);
	return style;
}

/*--------------------------------------------------------*/

export let renderColor = (colorObject,opacityOverride) => {
	if (typeof colorObject == 'undefined')
		return;

	let color = (typeof colorObject === 'string') ? colorObject : colorObject.color;
	if (typeof color === 'undefined')
		return;

	var opacity = (typeof opacityOverride !== 'undefined') ? opacityOverride : colorObject.opacity;
	if (typeof opacity == 'undefined')
		opacity = 1;
	
	if (color.substr(0,6) === 'color-') {
		if (!window.Wix || !window.Wix.Styles || !window.Wix.Styles.getColorByreference) 
			return null;

		color = window.Wix.Styles.getColorByreference(color).value;
		if (!color)
			return null;
	}

	if (color[0] === '#')
		return hexToRgba(color,opacity);

	// turn rgb to rgba + set the opacity
	if (color.substr(0,3) === 'rgb') {
		var prefix = color.substr(0, color.indexOf('('));
		var parts = color.substr(prefix.length+1,color.length-prefix.length-2).split(',');
		if (parts.length === 3)
			parts.push(opacity);
		else 
			parts[3] = opacity;

		return 'rgba('+parts.join(',')+')';
	}

	return color;
}

/*--------------------------------------------------------*/

export let getBreakpointStyle = (breakpointsStyles,width) => {
	let breakpoints = Object.keys(breakpointsStyles).sort();
	let breakpoint = (() => {
		for (let i = 0; i < breakpoints.length; i++) {
			if (width < breakpoints[i])
				return breakpoints[i];
		}
	})();
	
	return breakpointsStyles[breakpoint];
}

/*--------------------------------------------------------*/

export let shuffle = (a) => {
	for (let i = a.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[a[i], a[j]] = [a[j], a[i]];
	}

	return a;
}

/*--------------------------------------------------------*/

export let getLocal = (key) => {
	try {
		return localStorage[key];
	} catch (error) {
		console.log("Praise::getLocal",error);
	}

	return null;
}

export let deleteLocal = (key) => {
	try {
		delete localStorage[key];
	} catch (error) {
		console.log("Praise::deleteLocal",error);
	}

	return null;
}

/*--------------------------------------------------------*/